import { ReadFile } from '@paragon/client-tools';
import { BearingExtractionResult } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function extractBearings(imageFile: ReadFile) {
  return DesignService.post<BearingExtractionResult>('ai/extractBearings', { data: imageFile });
}
